import { NavLink } from "react-router-dom";
import { Box, Heading, Text, Button, Stack, IconButton } from "@chakra-ui/react";
import { BiArrowBack } from "react-icons/bi";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useTranslation } from "react-i18next";
import { routeTo } from "@/router/routeTo";
import { useAuth } from "@/hooks/useAuth";
import { useSafeBackNavigation } from "@/hooks/useSafeBackNavigation";

const NetworkError = ({ error }: { error: any }) => {
  const { t } = useTranslation(['errors']);
  useDocumentTitle(t('network.title'));
  const { isAuthenticated } = useAuth();

  const goBack = useSafeBackNavigation();


  return (
    <Box textAlign="center" py={10} px={6}>
      <Heading as="h2" size="xl" mb={4}>
        {t('network.title')}
      </Heading>

      <Text fontSize="lg" color="gray.600" mb={4}>
        {error?.message || 'An unexpected error occurred. Please try again.'}
      </Text>

      <Stack direction={{ base: 'column', sm: 'row' }} justify="center" gap={4} mt={6}>

        <IconButton onClick={goBack}>
          <BiArrowBack />
          Go Back
        </IconButton>

        <NavLink to={isAuthenticated ? routeTo.dashboard() : routeTo.root()}>
          <Button colorScheme="teal">
            {t('network.home') || 'Take me home'}
          </Button>
        </NavLink>
      </Stack>
    </Box>
  );
};

export default NetworkError;
